<template>
  <v-ons-page @show="checkPushOk()">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ pageLabel.title }} - {{ cultLabel }}
      </div>
    </v-ons-toolbar>

    <app-pull-hook-spinner v-if="isSync"></app-pull-hook-spinner>

    <div class="content">

      <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />

      <app-error-msg key="negoce-msg" v-if="isBlockHoraires" :list="negoceInfos.horaires.label.content"
                     :title="negoceInfos.horaires.label.title" :bg-color="negoceInfos.horaires.label.color" :is-hide-footer-msg="true">
      </app-error-msg>
      <app-error-msg key="negoce-msg" v-else-if="! negoceInfos.horaires && isEdit && negoceInfos.msg" :list="negoceInfos.msg.content"
                     :title="negoceInfos.msg.title" :bg-color="negoceInfos.msg.color" :is-hide-footer-msg="true">
      </app-error-msg>

      <app-error-msg key="error-msg" :list="errorMsgList"></app-error-msg>

      <v-ons-list v-if="isTech" modifier="noborder perflist">

        <app-label label="Agriculteur">
          <div slot="right" class="right align-right">
            {{ clientInfos ? clientInfos.name : 'n.c.' }}
          </div>
        </app-label>
        <template v-if="clientInfos">
          <app-label v-if="clientInfos.societe" label="Exploitation">
            <div slot="right" class="right align-right">
              {{ clientInfos.societe }}
            </div>
          </app-label>
          <app-label v-if="clientInfos.erp" label="Code tiers">
            <div slot="right" class="right">
              {{ clientInfos.erp }}
            </div>
          </app-label>
          <app-label label="Inscrit sur Perfarmer">
            <div slot="right" class="right">
              {{ clientInfos.is_contact ? 'Non' : 'Oui' }}
            </div>
          </app-label>
          <app-label v-if="clientInfos.config" label="Accès">
            <div slot="right" class="right align-right">
              <template v-for="(item, index) in clientInfos.config.label">
                {{ item }}
                <br :key="'content-' + index">
              </template>
            </div>
          </app-label>
          <v-ons-list-item modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="showClient">
              Modifier les informations
              <v-ons-progress-circular v-if="isSubmitGet" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
            </v-ons-button>
          </v-ons-list-item>
        </template>

      </v-ons-list>

      <v-ons-list modifier="noborder perflist">

        <template v-if="! isEdit && clients">
          <app-label input-id="inputClient" label="Nom de l'exploitation" :error-msg-list="errorMsgList"></app-label>
          <v-ons-list-item modifier="nodivider input">
            <div class="center">
              <v-ons-select :modifier="vente.client ? 'underbar' : 'underbar placeholder'" v-model="vente.client" ref="inputClient">
                <option value="" hidden>Sélectionnez une exploitation</option>
                <option v-for="(clientLabel, clientKey) in clients" :key="clientKey" :value="clientKey">
                  {{ clientLabel }}
                </option>
              </v-ons-select>
            </div>
          </v-ons-list-item>
        </template>

        <app-label v-if="isSelectIdPrix || isInputLabelPrix || vente.label_prix" input-id="inputIdPrix" label="Type de contrat"
                   :error-msg-list="errorMsgList">
          <div v-if="! isSelectIdPrix && ! isInputLabelPrix" slot="right" class="right align-right">
            {{ vente.label_prix }}
            {{ prixItem ? prixItem.suffix : '' }}
          </div>
        </app-label>
        <v-ons-list-item v-if="isSelectIdPrix" modifier="nodivider input">
          <div class="center">
            <v-ons-select :modifier="vente.id_prix !== '' ? 'underbar' : 'underbar placeholder'" v-model="vente.id_prix" ref="inputIdPrix">
              <option value="" hidden>Choisissez un type de contrat</option>
              <!-- si le prix n'est pas dans la liste -->
              <!-- avant la liste pour que si le label a changé on affiche toujours les mêmes infos -->
              <option v-if="vente.id_prix" :value="vente.id_prix" hidden>
                {{ vente.label_prix }}
              </option>
              <option v-for="(item, index) in prixList" :key="index" :value="item.id">
                {{ item.label }}
                {{ item.suffix }}
              </option>
            </v-ons-select>
          </div>
        </v-ons-list-item>
        <app-input v-else-if="isInputLabelPrix" input-id="inputIdPrix" ref="inputIdPrix" v-model="vente.label_prix"
                   placeholder="Entrez un type de contrat"></app-input>

        <template v-for="infosPrixItem in infosPrixList">
          <app-label :key="infosPrixItem.id + '_label'" :input-id="'inputInfosPrix_' + infosPrixItem.id"
                     :label="infosPrixItem.label + (infosPrixItem.unit ? ' (' + infosPrixItem.unit + ')' : '')"
                     :label-helper="(infosPrixItem.is_optional ? ' - Optionnel' : '') + (infosPrixItem.min ? ' - Minimum ' + infosPrixItem.min + infosPrixItem.unit : '')"
                     :error-msg-list="errorMsgList">
          </app-label>
          <app-input v-if="infosPrixItem.type == 'number'" :key="infosPrixItem.id + '_input'"
                     :input-id="'inputInfosPrix_' + infosPrixItem.id" :ref="'inputInfosPrix_' + infosPrixItem.id"
                     input-type="number" v-model.number="vente.infos_prix[infosPrixItem.id]"
                     :placeholder="infosPrixItem.placeholder" input-step="0.001">
          </app-input>
          <app-input v-else-if="infosPrixItem.type == 'text'" :key="infosPrixItem.id + '_input'"
                     :input-id="'inputInfosPrix_' + infosPrixItem.id" :ref="'inputInfosPrix_' + infosPrixItem.id"
                     v-model="vente.infos_prix[infosPrixItem.id]"
                     :placeholder="infosPrixItem.placeholder">
          </app-input>
          <v-ons-list-item v-else-if="infosPrixItem.type == 'textarea'" :key="infosPrixItem.id + '_textarea'" modifier="input">
            <textarea :input-id="'inputInfosPrix_' + infosPrixItem.id" :ref="'inputInfosPrix_' + infosPrixItem.id"
                      @click="$event.stopPropagation()" class="textarea textarea--transparent" rows="3" :placeholder="infosPrixItem.placeholder"
                      v-model="vente.infos_prix[infosPrixItem.id]"></textarea>
          </v-ons-list-item>
          <v-ons-list-item v-else :key="infosPrixItem.id + '_select'" modifier="nodivider input">
            <div class="center">
              <v-ons-select :modifier="vente.infos_prix[infosPrixItem.id] !== '' ? 'underbar' : 'underbar placeholder'"
                            v-model="vente.infos_prix[infosPrixItem.id]" :ref="'inputInfosPrix_' + infosPrixItem.id">
                <option value="" hidden>Choisissez une valeur</option>
                <option v-for="item in infosPrixItem.values" :key="item.id" :value="item.id">
                  {{ item.label }}
                </option>
              </v-ons-select>
            </div>
          </v-ons-list-item>
        </template>

        <app-label input-id="inputTonne" :label="'Quantité' + (tonneInfos.isShowInput ? ' (t)' : '')" :label-helper="tonneInfos.label"
                   :error-msg-list="errorMsgList">
          <div slot="right" class="right">
            {{ ! tonneInfos.isShowInput && vente.tonne ? vente.tonne.toLocaleString('fr', { minimumFractionDigits: 3 }) + '&nbsp;t' : '' }}
          </div>
        </app-label>
        <app-input v-show="tonneInfos.isShowInput" input-id="inputTonne" ref="inputTonne" input-type="number" v-model.number="vente.tonne"
                   placeholder="Entrez une quantité" input-step="0.001">
        </app-input>
        <template v-for="ledListItem in tonneInfos.ledList">
          <v-ons-list-item modifier="nodivider perfradio" :key="ledListItem.id + '-checkbox'"
                           :class="{'checkbox--disabled': ledList.selected != undefined && ledList.selected != ledListItem.id}">
            <div class="left">
              <v-ons-checkbox modifier="material" :input-id="'checkbox-' + ledListItem.id" :value="ledListItem.id" v-model="ledList.checkbox"
                              :disabled="ledList.selected != undefined && ledList.selected != ledListItem.id">
              </v-ons-checkbox>
            </div>
            <label class="center" :for="'checkbox-' + ledListItem.id">
              Tous les bons {{ ledListItem.label ? '(' + ledListItem.label + ')' : '' }}
              •
              {{ ledListItem.tonne.toLocaleString('fr', { minimumFractionDigits: 3 }) }}&nbsp;t
            </label>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider noborder" :key="ledListItem.id + '-list'">
            <v-ons-list modifier="noborder">
              <v-ons-list-item v-for="ledItem in tonneInfos.led" modifier="nodivider perfradio" :key="ledListItem.id + ledItem.id"
                              v-if="getLedItemProduit(ledItem) == ledListItem.id"
                              :class="{'checkbox--disabled': ledList.selected != undefined && ledList.selected != ledListItem.id}">
                <div class="left">
                  <v-ons-checkbox modifier="material" :input-id="'checkbox-' + ledItem.id" :value="ledItem.id" v-model="vente.led"
                                  :disabled="ledList.selected != undefined && ledList.selected != ledListItem.id">
                  </v-ons-checkbox>
                </div>
                <label class="center" :for="'checkbox-' + ledItem.id">
                  {{ ledItem.label }}
                  •
                  {{ ledItem.tonne.toLocaleString('fr', { minimumFractionDigits: 3 }) }}&nbsp;t
                </label>
              </v-ons-list-item>
            </v-ons-list>
          </v-ons-list-item>
        </template>

        <template v-if="(isEditable || vente.id_prix) && ! prixItemNull">
          <app-label input-id="inputPrix" :error-msg-list="errorMsgList"
                     :label="(prixItem && prixItem.input_label_prix ? prixItem.input_label_prix : 'Prix') + (isEditable ? ' (€/t)' : '' )">
            <div v-if="! isEditable" slot="right" class="right">
              {{ vente.prix !== '' ? vente.prix.toLocaleString('fr', { minimumFractionDigits: 2 }) + ' €/t' : 'Non disponible' }}
            </div>
          </app-label>
          <app-input v-if="isEditable" input-id="inputPrix" ref="inputPrix" input-type="number" v-model.number="vente.prix"
                    placeholder="Entrez un prix" input-step="0.01" modifier="longdivider input"></app-input>
        </template>

        <template v-if="negoceInfos.show_date">
          <app-label label="Date du contrat"></app-label>
          <v-ons-list-item modifier="nodivider input">
            <div class="center">
              <v-ons-row>
                <v-ons-col width="30%" style="margin-right: 10%">
                  <v-ons-select modifier="underbar" v-model="vente.date.jour">
                    <option v-for="jour in 31" :key="jour" :value="(jour < 10 ? '0' : '') + jour + '/'">
                      {{ jour }}
                    </option>
                  </v-ons-select>
                </v-ons-col>
                <v-ons-col width="60%">
                  <v-ons-select modifier="underbar" v-model="vente.date.mois">
                    <option v-for="mois in listMois" :key="mois.value" :value="mois.value">
                      {{ mois.label }}
                    </option>
                  </v-ons-select>
                </v-ons-col>
              </v-ons-row>
            </div>
          </v-ons-list-item>
        </template>

        <v-ons-list-item v-if="! isTech" modifier="nodivider label" expandable :expanded.sync="isShow.commentAgri">
          <div class="center">Ajouter un commentaire</div>
          <div class="expandable-content">
            <textarea @click="$event.stopPropagation()" class="textarea textarea--transparent" rows="3" placeholder="Écrire ici..."
                      v-model="vente.comment"></textarea>
          </div>
        </v-ons-list-item>

        <template v-else>
          <v-ons-list-item v-if="vente.comment" modifier="nodivider label">
            <div class="center">
              <div>
                Commentaire de l'agriculteur
                <br />
                «
                <i>
                  <span v-for='(comment, index) in vente.comment.split("\n")' :key="index"><br v-if="index" />{{ comment }}</span>
                </i>
                »
              </div>
            </div>
          </v-ons-list-item>
          <v-ons-list-item modifier="nodivider label" expandable :expanded.sync="isShow.commentTc">
            <div class="center">Ajouter un commentaire</div>
            <div class="expandable-content">
              <textarea @click="$event.stopPropagation()" class="textarea textarea--transparent" rows="3" placeholder="Écrire ici..."
                        v-model="vente.comment_tc"></textarea>
            </div>
          </v-ons-list-item>
        </template>

      </v-ons-list>

      <footer v-if="isTech" class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveVente" :disabled="isBlockHoraires">
          {{ pageLabel.cta }}
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
        <a v-if="clientInfos" href="#" @click="callClient(vente.client, clientInfos, 'vente demande')">
          <v-ons-icon icon="fa-phone"></v-ons-icon>
          Appeler l'agriculteur
        </a>
      </footer>
      <footer v-else class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="saveVente" :disabled="isDisabledCTA || isBlockHoraires">
          {{ pageLabel.cta }}
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
        <app-call-negoce :negoce-infos="negoceInfos" track-infos="demande" :is-appro="refCulture == 'appros'"></app-call-negoce>
      </footer>
      
    </div>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShow.otp" cancelable>
      <template slot="title">
        Code SMS
      </template>
      Veuillez renseigner le code reçu par {{ clientContact }} pour valider la signature :
      <v-ons-list modifier="noborder nopadding transparent">
        <app-input input-id="inputOtp" ref="inputOtp" v-model="otp.value" placeholder="Indiquez le code à 6 chiffres" @keyup-enter="closeKeyboard">
        </app-input>
      </v-ons-list>
      <p v-if="isShow.otpResend" style="margin: 0">
        <a href="#" @click="resendOTP">
          Renvoyer le code
          <v-ons-icon icon="redo" size="12px"></v-ons-icon>
        </a>
      </p>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="isShow.otp = false">Annuler</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="saveVente">
          Valider
        </v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';
import AppCallNegoce from '../partials/CallNegoce.vue';
import AppPullHookSpinner from '../partials/PullHookSpinner.vue';

import AppVenteNegoce from './VenteNegoce.vue';
import AppClientEdit from './ClientEdit.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppLabel, AppInput, AppCallNegoce, AppPullHookSpinner },
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      indexVente: -1,
      refCulture: '',
      refDestination: '',
      isSelectIdPrix: false,
      isInputLabelPrix: false,
      isDisabledCTA: false,
      vente: {
        client: '',
        id_prix: '',
        label_prix: '',
        tonne: '',
        prix: '',
        comment: '',
        comment_tc: '',
        date: {
          jour: '',
          mois: ''
        },
        etat: '',
        led: [],
        infos_prix: {}
      },
      ledList: {
        checkbox: [],
        selected: undefined
      },
      venteId: '',
      venteTonneInit: 0,
      otp: {
        value: '',
        isResend: false,
      },
      isShow: {
        commentAgri: false,
        commentTc: false,
        otp: false,
        otpResend: false
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    isSync() {
      return this.state.isSync;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    listMois() {
      return this.getListMois(this.campagne);
    },
    clientInfos() {
      if(this.isTech){
        return this.getClientInfosTech(this.data.negoce.clients, this.vente.client);
      }
      return null;
    },
    clientContact() {
      return this.getClientContact(this.isTech ? this.clientInfos : this.user);
    },
    negoceDate() {
      return this.data.negoce.date;
    },
    negoceInfos() {
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    },
    isTech() {
      return this.negoceInfos.is_tech;
    },
    clients() {
      if(! this.isTech && this.negoceInfos.clients && Object.keys(this.negoceInfos.clients).length > 1){
        return this.negoceInfos.clients;
      }
      return null;
    },
    isBlockHoraires() {
      if(this.isTech && this.isEdit){
        return false;
      }
      var isBlock = false;
      var now = new Date().getTime() / 1000;
      if(this.negoceInfos.horaires){
        if(now >= this.negoceInfos.horaires.close){
          isBlock = true;
        }
      }
      if (this.prixItem){
        isBlock = this.isBlockFromPrix(isBlock, this.prixItem, now);
      } else if(isBlock){
        for (let i = 0; i < this.prixList.length; i++) {
          var prixItem = this.prixList[i];
          if(! this.isBlockFromPrix(isBlock, prixItem, now)){
            return false; // au moins un prix non bloqué
          }
        }
      } else {
        var isAllBlock;
        for (let i = 0; i < this.prixList.length; i++) {
          var prixItem = this.prixList[i];
          if(this.isBlockFromPrix(isBlock, prixItem, now)){
            isAllBlock = true;
          } else {
            isAllBlock = false;
            break;
          }
        }
        if(isAllBlock === true){
          return true; // tous les prix sont bloqués
        }
      }
      return isBlock;
    },
    prixList() {
      var list = this.getListPrix(this.negoceInfos, this.refCulture, this.refDestination);
      if(this.clientInfos && this.clientInfos.config){
        var listFilter = this.filterListPrix(list, this.clientInfos.config);
        if(this.negoceInfos.prix_max){
          listFilter = this.maxListPrix(listFilter);
        }
        if(! listFilter.length && ! this.negoceInfos.block_prix){
          return list;
        }
        return listFilter;
      }
      return list;
    },
    prixItem() {
      for (let i = 0; i < this.prixList.length; i++) {
        var prixItem = this.prixList[i];
        if (prixItem.id == this.vente.id_prix) {
          return prixItem;
        }
      }
    },
    prixItemCours() {
      return this.prixItem && this.prixItem.cours !== '' && this.prixItem.cours !== null;
    },
    prixItemNull() {
      return this.isprixItemNull(this.prixItem);
    },
    infosPrixList() {
      var list = [];
      if(this.prixItem){
        if(this.prixItem.infos_prix){
          infosPrixLoop:
          for (let i = 0; i < this.prixItem.infos_prix.length; i++) {
            var infosPrixItem = this.prixItem.infos_prix[i];
            if(infosPrixItem.values && infosPrixItem.values.length == 0){
              continue;
            }
            var lisItem = {};
            for (const key in infosPrixItem) {
              if(key == 'values'){ // clone pour ne pas modifier le prix par référence
                lisItem.values = this.filterListPrix(infosPrixItem.values, this.clientInfos ? this.clientInfos.config : null);
              } else if(key == 'list'){
                lisItem.values = [];
                var infosPrixItemValues = this.negoceInfos.infos_prix[infosPrixItem.id].list[infosPrixItem.list];
                for (let j = 0; j < infosPrixItemValues.length; j++) {
                  var infosPrixItemValue = infosPrixItemValues[j];
                  lisItem.values.push({ ...infosPrixItemValue, ...this.negoceInfos.infos_prix[infosPrixItem.id].values[infosPrixItemValue.id] });
                }
                lisItem.values = this.filterListPrix(lisItem.values, this.clientInfos ? this.clientInfos.config : null);
              } else if(key == 'if'){
                for (const ifKey in infosPrixItem.if) {
                  if(! infosPrixItem.if[ifKey].includes(this.vente.infos_prix[ifKey])){
                    continue infosPrixLoop;
                  }
                }
              } else {
                lisItem[key] = infosPrixItem[key];
              }
            }
            list.push(lisItem);
          }
        }
        if(this.prixItem.tonne_surface){
          var surfaceItem = {
            id: 'surface',
            label: 'Surface',
            unit: 'ha',
            placeholder: 'Entrez une surface',
            type: 'number',
          };
          if(this.prixItem.surface_min){
            surfaceItem.label += ' - Minimum ' + this.prixItem.surface_min + 'ha';
          }
          list.push(surfaceItem);
          list.push({
            id: 'rendement',
            label: 'Rendement prévisionnel',
            unit: 'q/ha',
            placeholder: 'Entrez un rendement',
            type: 'number',
          });
        }
      }
      return list;
    },
    tonneInfos() {
      var infos = this.getTonneInfos(this.prixItem);
      var ledList = {};
      for (let i = 0; i < infos.led.length; i++) {
        var ledItem = infos.led[i];
        var ledListId = this.getLedItemProduit(ledItem);
        if(! ledList[ledListId]){
          ledList[ledListId] = {
            id: ledListId,
            tonne: ledItem.tonne,
            label: ledItem.produit_label
          };
        } else {
          ledList[ledListId].tonne += ledItem.tonne;
        }
      }
      ledList = Object.values(ledList);
      ledList.sort((a, b) => b.tonne - a.tonne);
      infos.ledList = ledList;
      return infos;
    },
    isEdit() {
      return this.indexVente > -1;
    },
    isEditable() {
      return (this.isTech && ! this.negoceInfos.block_prix) || (this.prixItemCours && this.prixItem.is_fix);
    },
    pageLabel() {
      var label = {};
      var labelVente;
      if(this.vente.etat == 'demande') {
        label.title = 'Demande';
      } else if(this.prixItemNull){
        label.title = 'Engagement';
        label.toast = 'Engagement modifié'; // forcément isEdit
        labelVente = "l'engagement";
      } else {
        label.title = 'Vente';
        label.toast = 'Vente modifiée';
        labelVente = 'la vente';
      }
      if(this.vente.etat == 'demande'){
        if(this.isTech){
          label.cta = 'Valider la demande';
          label.toast = 'Demande validée';
        } else if(this.isEdit){
          label.cta = 'Modifier ma demande';
          label.toast = 'Demande modifiée';
        } else {
          label.cta = 'Visualiser ma demande';
        }
      } else { // forcément isTech
        if(this.isEdit){
          label.cta = 'Modifier ' + labelVente;
        } else {
          label.cta = 'Visualiser ' + labelVente;
        }
      }
      return label;
    }
  },
  watch: {
    'vente.id_prix'(value, oldValue) {
      if (oldValue) { // reset prix infos
        this.vente.prix = '';
        this.vente.label_prix = '';
        this.vente.led = [];
        this.vente.infos_prix = {};
      }
      if (value && (oldValue || ! this.isEdit)) { // not already set
        this.setPrix();
        if(this.prixItem.is_led){
          this.vente.tonne = '';
        }
      }
    },
    'vente.led'(value, oldValue) {
      var ledListSelected;
      if(this.tonneInfos.led.length){
        var tonne = 0;
        for (let i = 0; i < this.tonneInfos.led.length; i++) {
          var ledItem = this.tonneInfos.led[i];
          if(value.includes(ledItem.id.toString())){
            tonne += ledItem.tonne;
            ledListSelected = this.getLedItemProduit(ledItem);
          }
        }
        this.vente.tonne = (tonne ? Math.round(tonne *1000)/1000 : '');
      } else if(! value.length && oldValue.length){
        this.vente.tonne = '';
      }
      this.ledList.selected = ledListSelected;
    },
    negoceInfos() { // from maj des prix OS cf created
      if (! this.isEdit) {
        this.vente.prix = '';
        this.setPrix();
      }
    },
    'vente.infos_prix': {
      handler(value, oldValue){
        if(! Object.keys(oldValue).length){
          return; // init via setPrix ou RAF si this.isEdit
        }
        this.setPrixFromInfosPrix();
      },
      deep: true
    },
    'vente.client'(){
      if(! this.isEdit && this.clients){ // modif ferme a posteriori
        this.setPrixFromPrixList();
      }
    },
    'ledList.checkbox'(value) {
      var ledIdList = [];
      if(value.length){
        for (let i = 0; i < this.tonneInfos.led.length; i++) {
          var ledItem = this.tonneInfos.led[i];
          if(this.getLedItemProduit(ledItem) == value[0]){
            ledIdList.push(ledItem.id);
          }
        }
      }
      this.vente.led = ledIdList;
    }
  },
  methods: {
    setPrix(){
      if(this.prixItem){
        if(this.prixItem.tonne_surface){
          this.$set(this.vente.infos_prix, 'surface', '');
          this.$set(this.vente.infos_prix, 'rendement', '');
        }
        if(this.prixItem.infos_prix){
          for (let i = 0; i < this.prixItem.infos_prix.length; i++) {
            var infosPrixItem = this.prixItem.infos_prix[i];
            this.$set(this.vente.infos_prix, infosPrixItem.id, '');
            if(this.clientInfos && this.clientInfos.infos_prix && this.clientInfos.infos_prix[infosPrixItem.id]){
              this.vente.infos_prix[infosPrixItem.id] = this.clientInfos.infos_prix[infosPrixItem.id];
            } else if(infosPrixItem.default){
              if(this.clients){
                this.vente.infos_prix[infosPrixItem.id] = infosPrixItem.default[this.vente.client];
              } else {
                this.vente.infos_prix[infosPrixItem.id] = infosPrixItem.default;
              }
            }
          }
        }
        if(! this.setPrixFromInfosPrix() && this.prixItemCours){
          this.vente.prix = Math.round(this.prixItem.cours *100)/100;
        }
        this.vente.label_prix = this.prixItem.label;
      }
    },
    setPrixFromPrixList(){
      this.isSelectIdPrix = false;
      if (this.prixList.length == 1) {
        this.vente.id_prix = this.prixList[0].id; // prix, label_prix set by watch vente.id_prix
      } else {
        this.vente.id_prix = '';
        if (this.prixList.length > 1) {
          this.isSelectIdPrix = true;
        } else if(this.isTech && ! this.negoceInfos.block_prix){
          this.isInputLabelPrix = true;
        } else {
          this.setNoPriceErrorMsg();
        }
      }
    },
    setPrixFromInfosPrix(){
      if(this.prixItem && this.prixItem.tonne_surface){
        if(this.vente.infos_prix.surface && this.vente.infos_prix.rendement){
          this.vente.tonne = Math.round(this.vente.infos_prix.surface * this.vente.infos_prix.rendement / 10 *1000)/1000;
        } else {
          this.vente.tonne = '';
        }
      }
      if(this.prixItemCours && this.infosPrixList){
        for (let i = 0; i < this.infosPrixList.length; i++) {
          var infosPrixItem = this.infosPrixList[i];
          if(infosPrixItem.values && this.vente.infos_prix[infosPrixItem.id]){
            for (let j = 0; j < infosPrixItem.values.length; j++) {
              var infosPrixItemValue = infosPrixItem.values[j];
              if(infosPrixItemValue.id == this.vente.infos_prix[infosPrixItem.id] && infosPrixItemValue.diff !== undefined){
                this.vente.prix = Math.round((this.prixItem.cours + infosPrixItemValue.diff) *100)/100;
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    checkPushOk(){
      var infoMsg = "Les notifications de validation de vos demandes de vente sont bloquées."
        + " Vous pouvez les activer depuis les paramètres du téléphone (section Notifications).";
      if (window.FirebasePlugin) {
        window.FirebasePlugin.hasPermission(function(hasPermission){
          if(! hasPermission){
            if(this.$md) {
              this.handleError({ is_custom: true, message: infoMsg }, '', true);
            } else {
              window.FirebasePlugin.grantPermission(function (hasPermission) {
                if(hasPermission){
                  store.state.push_ok = true;
                } else {
                  this.handleError({ is_custom: true, message: infoMsg }, '', true);
                }
              }.bind(this), function (errMsg) {
                this.handleError({ is_custom: true, message: "Erreur lors de l'activation des notifications push (" + errMsg + ")" }, '', true);
              }.bind(this));
            }
          }
        }.bind(this));
      }
    },
    setNoPriceErrorMsg() {
      this.setErrorMsgList('inputIdPrix', "Aucun prix n'est disponible pour cette culture chez "
        + this.negoceInfos.label + ". Essayez avec une autre culture."
      );
    },
    isBlockFromPrix(isBlock, prixItem, now){
      if(prixItem.horaires){
        if(isBlock && now >= prixItem.horaires.open){ // pas d'horaires
          isBlock = false;
        } else if(! isBlock && now < prixItem.horaires.open){ // ouveture tardive
          isBlock = true;
        }
        if(isBlock && now < prixItem.horaires.close){ // fermeture tardive
          isBlock = false;
        }
      }
      return isBlock;
    },
    async saveVente() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      if(! this.isEdit && this.clients && ! this.vente.client){
        this.setErrorMsgList('inputClient', "Le nom de l'exploitation est obligatoire");
      }

      if (this.vente.id_prix === '') {
        if (this.prixList.length) {
          this.setErrorMsgList('inputIdPrix', "Le type de contrat est obligatoire");
        } else if(this.isTech && ! this.negoceInfos.block_prix) {
          if(! this.vente.label_prix){
            this.setErrorMsgList('inputIdPrix', "Le type de contrat est obligatoire");
          }
        } else {
          this.setNoPriceErrorMsg();
          this.$scrollTop();
          return;
        }
      }

      if(this.prixItem && this.prixItem.infos_prix){
        var infosPrixListId = this.infosPrixList.map(item => { return item.id });
        for (let i = 0; i < this.prixItem.infos_prix.length; i++) {
          var infosPrixItem = this.prixItem.infos_prix[i];
          if(! infosPrixListId.includes(infosPrixItem.id)){
            continue;
          }
          
          const value = this.vente.infos_prix[infosPrixItem.id];
          if(value !== undefined && value !== '') {

            // Validation pour type integer avec min/max
            if(infosPrixItem.type === 'number' && ! this.negoceInfos.respo) {
              if(infosPrixItem.min !== undefined && value < infosPrixItem.min) {
                this.setErrorMsgList('inputInfosPrix_' + infosPrixItem.id, 
                  "Le champ «" + infosPrixItem.label + "» doit être supérieur ou égal à " + infosPrixItem.min);
              }
              if(infosPrixItem.max !== undefined && value > infosPrixItem.max) {
                this.setErrorMsgList('inputInfosPrix_' + infosPrixItem.id, 
                  "Le champ «" + infosPrixItem.label + "» doit être inférieur ou égal à " + infosPrixItem.max);
              }
            }
            
            // Validation pour type text avec format date (jj/mm/aaaa)
            if(infosPrixItem.type === 'text' && infosPrixItem.format === 'date') {
              const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
              
              if(!dateRegex.test(value)) {
                this.setErrorMsgList('inputInfosPrix_' + infosPrixItem.id, 
                  "Le champ «" + infosPrixItem.label + "» doit être au format jj/mm/aaaa");
              } else {
                // Validation de la date elle-même
                const [day, month, year] = value.split('/').map(Number);
                const date = new Date(year, month - 1, day);
                
                if(date.getDate() !== day || date.getMonth() !== month - 1 || date.getFullYear() !== year) {
                  this.setErrorMsgList('inputInfosPrix_' + infosPrixItem.id, 
                    "Le champ «" + infosPrixItem.label + "» doit être une date valide");
                } else if(infosPrixItem.date_debut && this.vente.infos_prix[infosPrixItem.date_debut]) {
                  const [dayDebut, monthDebut, yearDebut] = this.vente.infos_prix[infosPrixItem.date_debut].split('/').map(Number);
                  const dateDebut = new Date(yearDebut, monthDebut - 1, dayDebut);
                  if(dateDebut > date){
                    this.setErrorMsgList('inputInfosPrix_' + infosPrixItem.id, 
                      "Le champ «" + infosPrixItem.label + "» doit être postérieur à la date de début");
                  }
                }
              }
            }

          } else if(! infosPrixItem.is_optional){

            this.setErrorMsgList('inputInfosPrix_' + infosPrixItem.id, "Le champ «" + infosPrixItem.label + "» est obligatoire");
            
          }
        }
      }
      if(this.prixItem && this.prixItem.tonne_surface){
        if(! this.vente.infos_prix.surface){
          this.setErrorMsgList('inputInfosPrix_surface', "La surface est obligatoire");
        }
        if(! this.vente.infos_prix.rendement){
          this.setErrorMsgList('inputInfosPrix_rendement', "Le rendement prévisionnel est obligatoire");
        }
        if(this.prixItem.surface_min && this.vente.infos_prix.surface < this.prixItem.surface_min && ! this.negoceInfos.respo){
          this.setErrorMsgList('inputInfosPrix_surface', "La surface renseignée est inférieure à la surface minimum de "
            + this.prixItem.surface_min.toLocaleString('fr') + "ha"
          );
        }
      }

      if (!this.vente.tonne) {
        this.setErrorMsgList('inputTonne', "La quantité est obligatoire");
      } else if(this.tonneInfos.rav !== undefined && this.vente.tonne > this.tonneInfos.rav){
        this.setErrorMsgList('inputTonne', "La quantité renseignée est supérieure au reste à vendre de "
          + this.tonneInfos.rav.toLocaleString('fr') + "t"
        );
      } else if(this.tonneInfos.vol !== undefined && this.vente.tonne > this.tonneInfos.vol){
        this.setErrorMsgList('inputTonne', "La quantité renseignée est supérieure au volume disponible de "
          + this.tonneInfos.vol.toLocaleString('fr') + "t"
        );
      } else if(this.tonneInfos.min && this.vente.tonne < this.tonneInfos.min){
        this.setErrorMsgList('inputTonne', "La quantité renseignée est inférieure au volume minimum de "
          + this.tonneInfos.min.toLocaleString('fr') + "t"
        );
      } else if(this.tonneInfos.multiple && this.vente.tonne%this.tonneInfos.multiple){
        this.setErrorMsgList('inputTonne', "La quantité renseignée doit être un multiple de "
          + this.tonneInfos.multiple.toLocaleString('fr') + "t"
        );
      }

      if (this.vente.prix === '' && ! this.prixItemNull) {
        this.setErrorMsgList('inputPrix', "Le prix est obligatoire");
      }

      if (Object.keys(this.errorMsgList).length) {
        this.$scrollTop();
        return;
      }

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        data: {}
      };
      for (const key in this.vente) {
        if (key == 'date') {
          body.data.date = this.vente.date.jour + this.vente.date.mois;
        } else if (key == 'led') {
          if(this.tonneInfos.led && this.vente.led.length){
            body.data.led = JSON.parse(JSON.stringify(this.vente.led));
          }
        } else {
          body.data[key] = JSON.parse(JSON.stringify(this.vente[key]));
        }
      }

      if (! this.isEdit) {

        const negoceId = this.negoceId;
        const refCulture = this.refCulture;
        const refDestination = this.refDestination;
        this.pageStack.push({
          extends: AppVenteNegoce,
          data() {
            return {
              negoceId: negoceId,
              refCulture: refCulture,
              refDestination: refDestination,
              vente: body.data
            }
          }
        });

        this.sendTrackEvent('negoce click ' + this.negoceId + ' visu ' + refCulture + ' ' + refDestination);
        
      } else {

        body.index_vente = this.indexVente;
        body.id_vente = this.venteId;

        this.isSubmit = true;

        if(this.negoceInfos.is_otp){
          if(! this.isShow.otp){
            const responseOTP = await this.sendOTP(body);
            if(responseOTP){
              if(! responseOTP.error) {
                this.closeVente(); // bypass OTP
              }
            } else {
              this.isShow.otp = true;
              this.isSubmit = false;
            }
            return;
          } else {
            if(! this.otp.value){
              this.setErrorMsgList('inputOtp', "Pour signer le contrat, vous devez renseigner le code reçu par SMS");
              this.isSubmit = false;
              return;
            }
            this.addVenteHash(body);
            body.otp = this.otp.value;
            this.isShow.otp = false;
          }
        }

        const fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify(body);
        const callPath = this.$apiDomain
          + this.getPath(this.isTech ? '/negoce/vente' : '/negoce/demande')
          + '&negoce_date=' + this.negoceDate;
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          this.updateUserFromResponse(response.user);

          if(response.isMajNegoce){
            store.data.negoce.date = 0;
            this.ionicStorage.set('negoce', this.data.negoce);
            store.data.date = 0;
            this.ionicStorage.set('date', 0);
            this.$emit('update-if-needed');
          }

          if (this.isTech && this.negoceInfos.respo && response.idVente){
            this.redirectContrat(response.idVente);
          }

          this.closeVente();

        } catch(error) {
            this.handleError(error);
        }
      }
    },
    closeVente() {
      this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
      this.$showToast(this.pageLabel.toast);
    },
    async showClient() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      const urlParams = {
        user_date: this.user.date, // patch for cache issues
        id_negoce: this.negoceId,
        id_client: this.vente.client
      };

      this.isSubmitGet = true;

      const fetchInit = this.$getFetchInit('GET');
      const callPath = this.$apiDomain + this.getPath('/negoce/client', urlParams);
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        const negoceId = this.negoceId;
        const client = {
          ferme: '',
          tel: '',
          email: '',
          name: '',
          ligne4: '',
          cp: '',
          ville: '',
          erp: '',
          tc: '',
          silo: undefined
        };
        this.setJson(client, response.infos);
        const isInscrit = (this.clientInfos.is_contact ? false : true);
        const isAcces = (this.clientInfos.is_acces ? true : false);
        // Fiche rattachée à un compte Perfarmer dont beta sert les coordonnées de la FICHE
        // (et non celles du compte) : le TC peut les corriger, comme sur une fiche non rattachée.
        // Absent = beta enrichit encore avec le compte → on garde la lecture seule.
        const isContactEdit = (this.clientInfos.is_contact_edit ? true : false);

        this.pageStack.push({
          extends: AppClientEdit,
          data() {
            return {
              negoceId: negoceId,
              idContact: response.id,
              client: client,
              isInscrit: isInscrit,
              isAcces: isAcces,
              isContactEdit: isContactEdit
            }
          }
        });
        this.isSubmitGet = false;
      } catch(error) {
          this.handleError(error, 'de la récupération des informations');
      }
    },
    getTonneInfos(prixItem){
      var infos = { label: '', led: [], isShowInput: true };
      if(prixItem){
        if(this.isTech){
          if(this.clientInfos
          && this.clientInfos.led
          && this.clientInfos.led[this.campagne]
          && this.clientInfos.led[this.campagne][this.refCulture]
          && this.clientInfos.led[this.campagne][this.refCulture][this.refDestination]){
            for (let i = 0; i < this.clientInfos.led[this.campagne][this.refCulture][this.refDestination].length; i++) {
              let ledItem = this.clientInfos.led[this.campagne][this.refCulture][this.refDestination][i];
              if(ledItem.id_vente && ledItem.id_vente != this.venteId){
                continue;
              }
              if(this.isConfigValid(prixItem.config, ledItem.config)){
                infos.led.push(ledItem);
              }
            }
          }
          if(this.clientInfos
          && this.clientInfos.rav
          && this.clientInfos.rav[this.campagne]
          && this.clientInfos.rav[this.campagne][this.refCulture]
          && this.clientInfos.rav[this.campagne][this.refCulture][this.refDestination]){
            for (let i = 0; i < this.clientInfos.rav[this.campagne][this.refCulture][this.refDestination].length; i++) {
              let ravItem = this.clientInfos.rav[this.campagne][this.refCulture][this.refDestination][i];
              if(this.isConfigValid(prixItem.config, ravItem.config)){
                if(! infos.rav){
                  infos.rav = [];
                  infos.ravLabel = [];
                }
                infos.rav.push(ravItem.tonne);
                let ravLabel = ravItem.tonne.toLocaleString('fr') + 't';
                if(ravItem.label){
                  ravLabel += ' (' + ravItem.label + ')';
                }
                infos.ravLabel.push(ravLabel);
              }
            }
          }
          if(! infos.rav && prixItem.rav !== undefined){
            infos.rav = [prixItem.rav];
            infos.ravLabel = [prixItem.rav.toLocaleString('fr') + 't'];
          }
        } else {
          if(prixItem.led){
            for (let i = 0; i < prixItem.led.length; i++) {
              let ledItem = prixItem.led[i];
              if(ledItem.id_vente && ledItem.id_vente != this.venteId){
                continue;
              }
              if(ledItem.client && this.vente.client && ledItem.client != this.vente.client){
                continue;
              }
              infos.led.push(ledItem);
            }
          }
          if(prixItem.rav !== undefined){
            if(Array.isArray(prixItem.rav)){
              infos.rav = [];
              infos.ravLabel = [];
              for (let i = 0; i < prixItem.rav.length; i++) {
                let ravItem = prixItem.rav[i];
                if(ravItem.client && this.vente.client && ravItem.client != this.vente.client){
                  continue;
                }
                infos.rav.push(ravItem.tonne);
                let ravLabel = ravItem.tonne.toLocaleString('fr') + 't';
                if(ravItem.label){
                  ravLabel += ' (' + ravItem.label + ')';
                }
                infos.ravLabel.push(ravLabel);
              }
              if(! infos.rav.length){
                delete infos.rav;
              } else if(infos.rav.length > 1 && ! infos.rav[0]){
                infos.rav.splice(0, 1);
                infos.ravLabel.splice(0, 1);
              }
            } else {
              infos.rav = [prixItem.rav];
              infos.ravLabel = [prixItem.rav.toLocaleString('fr') + 't'];
            }
          }
        }
        if(prixItem.is_led && ! infos.led.length){
          infos.label += ' - Aucun lot en dépôt disponible'
        }
        if(prixItem.is_led || (infos.led.length && this.vente.led.length)){
          if(! this.negoceInfos.respo){
            infos.isShowInput = false;
          }
        } else if(this.vente.tonne !== ''){
          infos.led = [];
        }
        if(prixItem.tonne_min && (! this.vente.led.length || prixItem.tonne_min_led)){
          infos.min = prixItem.tonne_min;
          infos.label += ' - Minimum ' + infos.min + 't'
        }
        if(prixItem.tonne_multiple){
          infos.multiple = prixItem.tonne_multiple;
          infos.label += ' - Par multiple de ' + infos.multiple + 't'
        }
        if(infos.rav){
          if(this.vente.led.length || this.isprixItemNull(prixItem)){
            delete infos.rav;
          } else {
            infos.label = ' - Reste à vendre ' + infos.ravLabel.join(' + ') + infos.label;
            if(prixItem.is_rav === false){
              delete infos.rav;
            } else {
              infos.rav = infos.rav.reduce((result, val) => { return Math.max(result, val); }, 0);
              infos.rav += this.venteTonneInit;
              infos.rav = Math.round(infos.rav *1000)/1000;
            }
          }
        }
        delete infos.ravLabel;
        if(prixItem.vol){
          infos.vol = prixItem.vol;
          infos.vol += this.venteTonneInit;
          infos.vol = Math.round(infos.vol *1000)/1000;
          infos.label += ' - Volume disponible ' + infos.vol + 't'
        }
        if(this.negoceInfos.respo){
          delete infos.min;
          delete infos.multiple;
          delete infos.rav;
          delete infos.vol;
        }
        if(prixItem.tonne_surface){
          infos.isShowInput = false;
        }
      }
      return infos;
    },
    getLedItemProduit(ledItem){
      return (ledItem.produit == undefined ? '' : ledItem.produit);
    },
    isprixItemNull(prixItem){
      return prixItem && prixItem.cours === null
    },
    ravListPrix(list){
      var listFilter = [];
      for (let i = 0; i < list.length; i++) {
        var item = list[i];
        var tonneInfos = this.getTonneInfos(item);
        if(tonneInfos.rav !== 0){
          listFilter.push(item);
        }
      }
      return listFilter;
    }
  },
  created() {
    // maj des prix OS
    store.state.isSync = true;
    if(this.isTech){
      this.$emit('call-api', {
        is_silent: true,
        done: function () { store.state.isSync = false; },
        error: function () { this.$showToast('Échec de la mise à jour des prix'); }.bind(this),
      });
    } else {
      this.isDisabledCTA = true;
      this.$emit('call-api', {
        is_silent: true,
        done: function () { store.state.isSync = false; },
        success: function () { this.isDisabledCTA = false; }.bind(this),
        error: function (error) { this.handleError(error, 'de la mise à jour des prix'); }.bind(this)
      });
    }
    if (this.isEdit) {
      this.setVente(this.strategie.done[this.indexVente]);
      this.venteId = this.strategie.done[this.indexVente].id;
      this.venteTonneInit = this.strategie.done[this.indexVente].tonne;
      var dateArray = this.vente.date.split('/');
      this.$set(this.vente, 'date', {
        jour: dateArray[0] + '/',
        mois: dateArray[1] + '/' + dateArray[2]
      });
      if (this.prixList.length == 1 && this.prixList[0].id == this.vente.id_prix){
        // un seul prix et celui de la vente
      } else if(this.prixList.length) {
        this.isSelectIdPrix = true;
      } else if(this.isTech && ! this.negoceInfos.block_prix){
        this.isInputLabelPrix = true;
      }
    } else {

      var jour = new Date().getDate();
      this.vente.date.jour = (jour < 10 ? '0' : '') + jour + '/'
      this.vente.date.mois = this.listMois[0].value;

      if (this.vente.id_prix) {
        this.setPrix();
      } else {
        this.setPrixFromPrixList();
      }

      if (this.isTech) {
        this.vente.etat = 'vente';
      } else {
        this.vente.etat = 'demande';
        if(this.negoceInfos.clients && Object.keys(this.negoceInfos.clients).length == 1){
          this.vente.client = Object.keys(this.negoceInfos.clients)[0];
        }
      }
    }
  },
  mounted() {
    if (this.vente.comment) {
      this.isShow.commentAgri = true;
    }
    if (this.vente.comment_tc) {
      this.isShow.commentTc = true;
    }
  }
}
</script>